import {
  GET_XM_ESTIMATED,
  GET_XM_ESTIMATED_SUCCESS,
  GET_XM_ESTIMATED_FAILURE,
} from '../actions/xmEstimated';

/**
 * Reducer for SSM xmEstimated API response.
 * Handles loading, error, and data state for autopay edit confirmation.
 */
const INITIAL_STATE = {
  loading: false,
  error: false,
};

export default function xmEstimatedReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case GET_XM_ESTIMATED:
      return {
        ...state,
        loading: true,
      };
    case GET_XM_ESTIMATED_SUCCESS: {
      const { autoPayDate, cycleTotal } = action.payload || {};
      return {
        ...state,
        loading: false,
        data: {
          autoPayDate,
          cycleTotal,
        },
      };
    }
    case GET_XM_ESTIMATED_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };
    default:
      return state;
  }
}
